import countries from 'model/address/collection/country'

const get = attribute => key => countries.find(x => x.key === key)?.[attribute]
const has = attribute => key => !!get(attribute)(key)

/**
 * Returns whether the requested country has a `state` field.
 *
 * @type {function(*): boolean}
 */
export const hasState = has('state')

/**
 * Returns whether the requested country has a `houseNumber` field.
 *
 * @type {function(*): boolean}
 */
export const hasHouseNumber = has('houseNumber')

/**
 * Returns the `stateTerm` value of the requested country.
 * @type {function(*): *}
 */
export const getStateTerm = get('stateTerm')
